module.exports = __webpack_public_path__ + "static/media/close-img.225b56cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-img.svg
// module id = 95
// module chunks = 0